var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-table',{attrs:{"responsive":"","stacked":"sm","no-border-collapse":"","small":"","hover":"","items":_vm.items,"fields":_vm.fields},scopedSlots:_vm._u([{key:"cell(origin)",fn:function({
      item: {
        origin: { type, city_name },
      },
    }){return [_c('p',[_vm._v(_vm._s(type))]),_c('p',[_vm._v(_vm._s(city_name))])]}},{key:"cell(destination)",fn:function({
      item: {
        destination: { type, city_name },
      },
    }){return [_c('p',[_vm._v(_vm._s(type))]),_c('p',[_vm._v(_vm._s(city_name))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }